import { neutral } from '@guardian/src-foundations/palette';
import React from 'react';
export const Star = ({ starId, isEmpty, }) => {
    if (isEmpty)
        return (React.createElement("svg", { width: "14", height: "13", viewBox: "0 0 14 13" },
            React.createElement("path", { id: `star-${starId}`, clipPath: `url(#clip-${starId})`, strokeWidth: "2", stroke: neutral[7], fill: "transparent", d: "M0 5.2L3.7 8l-1.4 4.6.5.4 3.7-2.8 3.7 2.8.5-.4L9.3 8 13 5.2l-.2-.6H8.2L6.8 0h-.6L4.8 4.6H.2l-.2.6z" }),
            React.createElement("clipPath", { id: `clip-${starId}` },
                React.createElement("use", { xlinkHref: `#star-${starId}`, stroke: "none" }))));
    return (React.createElement("svg", { width: "14", height: "13", viewBox: "0 0 14 13" },
        React.createElement("path", { fill: neutral[7], strokeWidth: "0", d: "M0 5.2L3.7 8l-1.4 4.6.5.4 3.7-2.8 3.7 2.8.5-.4L9.3 8 13 5.2l-.2-.6H8.2L6.8 0h-.6L4.8 4.6H.2l-.2.6z" })));
};
